/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import {
  RadioGroup,
  ExpandableSquareButtonGroup,
  ExpandableProductCardGroup,
} from '../../../../UiKit';
import { componentMap } from '../../../serverDrivenUIComponents/compMapping';
import { Check } from 'sushiweb/Icons';
import { white } from 'sushiweb/tokens/color';
import {
  IssueItemEditDetailsClickEvent,
  IssueItemEditUploadMediaClickEvent,
  IssueItemResolutionSelectionEvent,
} from '../../../../analytics/raise-an-issue/events';
import { MetricsForJumboEvent } from '../../../../analytics/constants';
import Button from '../../../ComponentsV1/Button';
import { Info } from 'lucide-react';
import { ToolTip } from '../../../ComponentsV1/ToolTip/Tooltip';

const showThumbNail = (countToShow, items, count) => {
  return items.map((item, ind) => {
    if (ind >= countToShow) return;
    return (
      <span
        className='tw-rounded-lg tw-bg-base-white tw-w-16 tw-h-16 tw-flex tw-justify-center tw-items-center tw-text-grey-500 tw-text-200 tw-font-medium  tw-relative tw-border tw-border-solid tw-border-grey-200'
        role='img'
        aria-label='item'
        key={`${item?.title}_${ind}`}
      >
        {ind === countToShow - 1 && countToShow != count ? (
          `+${count - (countToShow - 1)}`
        ) : (
          <img
            src={item?.image || item?.media_url}
            alt='item'
            width='100%'
            height='100%'
            className='tw-rounded-xl'
          />
        )}
        <div className='tw-absolute tw-right-1 tw-bottom-1'>
          <div className='tw-rounded-full tw-bg-green-700 tw-p-1'>
            <Check size={8} color={white} />
          </div>
        </div>
      </span>
    );
  });
};

const getOptionDetailCard = (
  children = [],
  setValues = () => {},
  setProductAttribute,
) => {
  if (!Array.isArray(children)) {
    return null;
  }

  return children.map((child, index) => {
    if (!child || !child.type) return null;

    if (child.type === 'expandable_square_button_group') {
      return (
        <ExpandableSquareButtonGroup
          props={child || {}}
          setProductAttribute={setProductAttribute}
          key={index}
        />
      );
    }

    if (child.type === 'expandable_product_card_group') {
      return (
        <ExpandableProductCardGroup
          props={child || {}}
          setProductAttribute={setProductAttribute}
          key={index}
        />
      );
    }

    const CompName = componentMap[child.type] || null;
    if (!CompName) return null;

    return (
      <div className='tw-mt-5 tw-w-full' key={index}>
        <CompName
          details={child}
          className='!tw-font-medium tw-text-zinc-800 !tw-text-[1.3rem]'
          setValues={setValues}
        />
      </div>
    );
  });
};

const getRadioOptions = (supportOptions, setValues, setProductAttribute) => {
  const optionsList = supportOptions.map((option) => {
    return {
      text: option.title,
      key: option?.input?.key,
      sub_text: option.subtitle,
      st_style: {
        color: '#E03546',
        fontSize: '1.2rem',
        fontWeight: '500',
      },
      enable_reason: option.enable_reason,
      er_style: {
        color: '#318616',
        fontSize: '1.1rem',
        fontWeight: '500',
      },
      value: option.slug,
      disabled: !option.enabled,
      radioOptionDetailsCard: getOptionDetailCard(
        option?.children,
        setValues,
        setProductAttribute,
      ),
      // to see if substitution flow is present or not
      substitution_flow: {
        is_substitution_flow:
          Array.isArray(option?.children) &&
          option.children.some(
            (child) => child?.type === 'expandable_product_card_group',
          ),
        subs_items:
          Array.isArray(option?.children) &&
          option.children.some(
            (child) => child?.type === 'expandable_product_card_group',
          )
            ? option.children.find(
                (child) => child?.type === 'expandable_product_card_group',
              )?.product_card_options ?? null
            : null,
      },
      approve: option?.approve,
      save_for_later: option?.save_for_later,
      resolve_now: option?.resolve_now,
    };
  });
  return optionsList;
};

export default function ActionOptions({
  orderId = null,
  cartId = null,
  userId = null,
  PendingIssuesFlow = false,
  resolve = () => {},
  resolutionOptionDetails,
  setShowResolutionOptions,
  isLoading = false,
  handleComplaintImgvisibilty = () => {},
  availableComplaintImages = [],
  complaintType = null,
  isDSRFlow = false,
}) {
  let { item_thumbnails, support_options, complaint_id, selected_items } =
    resolutionOptionDetails;

  const [showCBLBtn, setShowCBLBtn] = useState(false);
  const [mainResolutionOption, setMainResolutionOption] = useState(null);
  const [detailedResolutionOption, setDetailedResolutionOption] =
    useState(null);
  const [valuesForResolve, setValues] = useState({});
  const [ProductAttribute, setProductAttribute] = useState(null);

  const [isSaveForLaterEnabled, setIsSaveForEnabled] = useState({
    enabled: false,
    reason: '',
  });
  const [isResolveNowEnabled, setIsResolveNowEnabled] = useState({
    enabled: true,
    reason: '',
  });

  useEffect(() => {
    if (isDSRFlow) {
      setMainResolutionOption(true);
    }
  }, [isDSRFlow]);

  useEffect(() => {
    const RadioOptions = resolutionOptionDetails?.support_options?.options;
    if (!Array.isArray(RadioOptions) || RadioOptions.length === 0) {
      setShowCBLBtn(false);
      return;
    }

    const isCBLVisible = RadioOptions.every((option) =>
      option?.save_for_later ? option.save_for_later.is_visible : false,
    );

    setShowCBLBtn(isCBLVisible);
  }, [resolutionOptionDetails]);

  useEffect(() => {
    const finalResolutionOption = {
      ...valuesForResolve,
      [support_options?.input?.key]: mainResolutionOption,
      product_attribute: ProductAttribute,
    };
    setDetailedResolutionOption(finalResolutionOption);
  }, [ProductAttribute, valuesForResolve, mainResolutionOption]);

  const selectRadioOption = (radio, item) => {
    // Track the selection of radio options for resolution
    IssueItemResolutionSelectionEvent({
      [MetricsForJumboEvent.cart_id]: cartId,
      [MetricsForJumboEvent.order_id]: orderId,
      [MetricsForJumboEvent.customer_id]: userId,
      [MetricsForJumboEvent.feature_meta]: {
        resolution_type: radio,
        complaint_id,
        complaint_type: complaintType,
        substitution_flow_data: item?.substitution_flow
          ? JSON.stringify(item.substitution_flow)
          : '',
      },
    });
    if (!item?.key) setValues({});

    setIsSaveForEnabled({
      enabled: item?.save_for_later?.enabled,
      reason: item?.save_for_later?.disabled_reason || '',
    });
    setIsResolveNowEnabled({
      enabled: item?.resolve_now?.enabled ?? true,
      reason: item?.resolve_now?.disabled_reason || '',
    });

    setMainResolutionOption(radio);
  };

  const editItemSelection = () => {
    setShowResolutionOptions();
    handleComplaintImgvisibilty();
  };

  return (
    <div className='tw-flex tw-flex-col tw-gap-6'>
      {/* Cx uploaded complaints images */}
      {availableComplaintImages?.length > 0 && (
        <div className='tw-p-5 tw-bg-white tw-rounded-lg tw-justify-between tw-shadow-none tw-items-center tw-border tw-border-solid tw-border-red-200'>
          <div className='tw-flex tw-flex-col tw-gap-2'>
            <span className='tw-font-medium tw-text-[1.4rem] tw-text-red-600 tw-leading-none'>
              Complaint Images
            </span>
            <span
              className='tw-cursor-pointer tw-font-medium tw-text-base-green tw-text-[1.2rem] tw-leading-none'
              onClick={() => {
                // Track the click event for editing or changing complaint images
                if (cartId && orderId && userId) {
                  IssueItemEditUploadMediaClickEvent({
                    [MetricsForJumboEvent.cart_id]: cartId,
                    [MetricsForJumboEvent.order_id]: orderId,
                    [MetricsForJumboEvent.customer_id]: userId,
                    [MetricsForJumboEvent.feature_meta]: {
                      complaint_id,
                      complaint_type: complaintType,
                    },
                  });
                }
                editItemSelection();
              }}
            >
              Edit/Change
            </span>
          </div>
          <div className='tw-flex tw-gap-3'>
            {showThumbNail(
              3,
              availableComplaintImages,
              availableComplaintImages?.length,
            )}
          </div>
        </div>
      )}

      {item_thumbnails?.count > 0 && (
        <div className='tw-p-5 tw-bg-white tw-rounded-lg tw-justify-between tw-shadow-none tw-items-center'>
          <div className='tw-flex tw-flex-col tw-gap-2'>
            <span className='tw-font-medium tw-text-[1.4rem] tw-text-zinc-700 tw-leading-none'>
              {item_thumbnails?.count}{' '}
              {item_thumbnails?.count === 1 ? 'item' : 'items'} selected
            </span>
            <span
              className='tw-cursor-pointer tw-font-medium tw-text-base-green tw-text-[1.2rem] tw-leading-none'
              onClick={() => {
                // Track the click event for editing or changing complaint images
                if (cartId && orderId && userId) {
                  IssueItemEditDetailsClickEvent({
                    [MetricsForJumboEvent.cart_id]: cartId,
                    [MetricsForJumboEvent.order_id]: orderId,
                    [MetricsForJumboEvent.customer_id]: userId,
                    [MetricsForJumboEvent.feature_meta]: {
                      complaint_id,
                      complaint_type: complaintType,
                    },
                  });
                }
                editItemSelection();
              }}
            >
              Edit / Change
            </span>
          </div>
          <div className='tw-flex tw-gap-3'>
            {showThumbNail(
              item_thumbnails?.max_count > 3 ? 3 : item_thumbnails?.max_count,
              item_thumbnails.items,
              item_thumbnails.count,
            )}
          </div>
        </div>
      )}

      {/* Resolution Options */}
      <div className='tw-flex tw-flex-col tw-text-base-black tw-text-300 tw-font-extrabold tw-gap-6 tw-mt-2'>
        <span className='tw-text-[1.5rem] tw-text-zinc-700 tw-font-medium'>
          {isDSRFlow
            ? 'Item selected for door step return'
            : support_options?.header}
        </span>
        <div className='tw-flex tw-flex-col'>
          {isDSRFlow ? (
            <div
              className='tw-flex tw-w-full tw-flex-col tw-gap-5'
              css={`
                & label {
                  background: #f8f8f8;
                  border: none;
                  border-radius: 5px;
                  padding: 1.2rem;
                }
              `}
            >
              {selected_items &&
              Array.isArray(selected_items) &&
              selected_items.length > 0
                ? selected_items.map((item, index) => (
                    <div
                      key={index}
                      className='tw-bg-white tw-rounded-lg tw-flex tw-justify-between tw-items-start'
                    >
                      <div className='tw-flex tw-flex-col tw-mt-4'>
                        <span className='tw-font-medium tw-text-[1.3rem] tw-text-zinc-800'>
                          {item?.item_text}
                        </span>
                        <span className='tw-font-regular tw-text-[1.2rem] tw-text-orange-600'>
                          {item?.item_category}
                        </span>
                      </div>
                      <div className='tw-w-32 tw-h-32'>
                        <img src={item?.item_image_url} alt='item_image' />
                      </div>
                    </div>
                  ))
                : null}
            </div>
          ) : (
            <div
              className='tw-flex tw-w-full tw-flex-col tw-gap-5'
              css={`
                & label {
                  background: #f8f8f8;
                  border: none;
                  border-radius: 5px;
                  padding: 1.2rem;
                }
              `}
            >
              <RadioGroup
                items={getRadioOptions(
                  support_options?.options || [],
                  setValues,
                  setProductAttribute,
                )}
                radioGroupWidth='100%'
                selectOption={selectRadioOption}
                showRadioOptionDetailsCard='isChecked'
              />
            </div>
          )}
        </div>
      </div>

      {/* Footer Buttons */}
      {detailedResolutionOption && (
        <div
          className={
            'tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-flex tw-flex-col tw-gap-5 tw-shadow-lg tw-border-solid tw-border-[0.5px] !tw-border-x-0 !tw-border-b-0 tw-border-grey-200 tw-p-5 tw-bg-white'
          }
        >
          <div className='tw-flex tw-flex-col tw-gap-2'>
            <Button
              onClick={() => {
                if (!mainResolutionOption || !isResolveNowEnabled.enabled)
                  return;
                resolve(detailedResolutionOption);
              }}
              disabled={
                isLoading ||
                !mainResolutionOption ||
                !isResolveNowEnabled.enabled ||
                (mainResolutionOption === 'exchange_or_refund' &&
                  !ProductAttribute)
              }
              className={`tw-p-2 ${!PendingIssuesFlow ? 'tw-mb-0' : ''}`}
              data-dd-action-name='Resolve Now'
              title={
                <ToolTip
                  content={isResolveNowEnabled.reason || 'Disabled'}
                  disabled={isResolveNowEnabled.enabled}
                >
                  <div className='tw-flex tw-items-center tw-leading-none tw-gap-2 tw-justify-center'>
                    {isDSRFlow ? 'Return Now' : 'Resolve Now'}
                    {!isResolveNowEnabled.enabled && <Info size={18} />}
                  </div>
                </ToolTip>
              }
            />
          </div>

          {/* Don't show CBL button for pending issues flow */}
          {!PendingIssuesFlow && showCBLBtn ? (
            <div className='tw-flex tw-flex-col tw-gap-2'>
              <Button
                onClick={() => {
                  if (isLoading || !isSaveForLaterEnabled.enabled) return;
                  resolve(detailedResolutionOption, 'approve');
                }}
                className={'tw-mt-0 tw-p-2'}
                disabled={isLoading || !isSaveForLaterEnabled.enabled}
                data-dd-action-name='Save For Later'
                title={
                  <ToolTip
                    content={isSaveForLaterEnabled.reason || 'Disabled'}
                    disabled={isSaveForLaterEnabled.enabled}
                  >
                    <div className='tw-flex tw-items-center tw-leading-none tw-gap-2 tw-justify-center'>
                      Save For Later
                      {!isSaveForLaterEnabled.enabled && <Info size={18} />}
                    </div>
                  </ToolTip>
                }
              />
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
}
